import { useNavigate } from "react-router-dom";
import { Seo } from "@/components/Seo";
import ClassShowcase from "@/components/site/ClassShowcase";

export default function ProgramsPage() {
  const navigate = useNavigate();
  return (
    <main data-testid="page-programs">
      <Seo
        title="Programs — Nursing Algebra, Books, Arts & Leadership"
        description="Explore every Delta DL Enterprise, LLC program: Nursing Algebra, Books, Arts, Leadership, and one-on-one Math Tutoring with Dr. Dennis Louden."
        path="/programs"
      />
      <ClassShowcase
        onEnroll={(key) =>
          navigate(`/enroll${key ? `?course=${encodeURIComponent(key)}` : ""}`)
        }
      />
    </main>
  );
}
